import { Container } from 'pixi.js';
/**
 */
export class UiContainer extends Container {
  /**
   */
  constructor() {
    super();
  }

  /**
   */
  init() {}

  /**
   *
   * @param width
   * @param height
   */
  resize(width: number, height: number) {}
}
